<script>
    import { InputText, Select, SelectX, TextArea, Row } from '../UI'
    import { confImp as confImp_ } from '$lib/conf'
    import { validarCuit, validarNoNull } from '$lib/utils'
    import dictionaries from '../../stores/dictionaries'
    export let data = {}
    export let restricted = false
    export let inputs = null
    export let editable = true
    export let valid = false
    export let dynamic = true
    export let providerSiniestros = false

    // @ts-ignore
    $: allowedInputs = inputs instanceof Array ? inputs : []

    $: showAll = !(allowedInputs.length > 0)
    let confImp = confImp_
    if (
        providerSiniestros &&
        confImp.general.findIndex((x) => x.name === 'docu_f931_ii') === -1
    ) {
        confImp.general.push({
            // Forfumlario obligatorio para proveedores de siniestros
            title: 'Adjuntar Formulario F931 o Declaración de No empleados',
            label: 'Formulario F931 o Declaración de No empleados',
            type: '2',
            name: 'docu_f931_ii',
            inputs: ['files*'],
            required: true,
        })
    }
    function allowInputs() {
        let args = Array.prototype.slice.call(arguments)
        return showAll || args.some((x) => allowedInputs.includes(x))
    }
    if (dynamic && data.tipo_doc_dp == '2' && data.no_doc_dp) {
        data.cuit_ii = data.no_doc_dp
    }
    let documentation = {}
    $: valid =
        Object.values(documentation).length > 0
            ? Object.values(documentation).every((x) => x === true)
            : true
    $: ({
        condicion_imp_iva_ii,
        condicion_imp_ganancias_ii,
        condicion_imp_ingresos_ii,
    } = data)
    if (dynamic && condicion_imp_ingresos_ii) {
        data.docu_iibb_ii = undefined
    }
    if (providerSiniestros === true) {
        data.tipo_proveedor_ii = '4'
        data.condicion_imp_ganancias_ii = '0'
    }
    $: validations = {
        tipo_proveedor_ii: validarNoNull,
        cuit_ii: validarCuit,
        condicion_imp_iva_ii: validarNoNull,
        condicion_imp_ganancias_ii: validarNoNull,
        condicion_imp_ingresos_ii: validarNoNull,
        no_ingresos_brutos_ii: (n) =>
            typeof n === 'string' && /^[0-9]{8,14}$/.test(n),
        empleador_ii: (v) =>
            data.condicion_imp_iva_ii === '1' ? validarNoNull(v) : true,
    }

    $: validationFields = Object.entries(validations)
        .filter(([k]) => k in data)
        .map(([field, func]) => [field, func(data[field])])
        // @ts-ignore
        .reduce((acc, [k, v]) => ({ ...acc, [k]: v }), {})

    $: valid = Object.values(validationFields).every((x) => x === true)
</script>

{#if allowInputs('tipo_proveedor_ii', 'cuit_ii')}
    <Row>
        {#if allowInputs('tipo_proveedor_ii') && !providerSiniestros}
            <Select
                required
                disabled={!editable}
                bind:value={data.tipo_proveedor_ii}
                name="tipo_proveedor_ii"
                label="Tipo Proveedor"
                validation={validations.tipo_proveedor_ii}
                options={$dictionaries.tipo_proveedor}
                placeholder="Seleccione una opción."
            />
        {/if}
        {#if allowInputs('cuit_ii')}
            <InputText
                required
                disabled={!editable || restricted}
                errorMsg="Ingrese un CUIT válido."
                info="El CUIT debe contener 11 dígitos numéricos."
                validation={validations.cuit_ii}
                name="cuit_ii"
                label="CUIT N°"
                bind:value={data.cuit_ii}
            />
        {/if}
    </Row>
{/if}
{#if allowInputs('condicion_imp_iva_ii')}
    <Row>
        <SelectX
            required
            disabled={!editable}
            name="condicion_imp_iva_ii"
            label="Condición Frente al I.V.A"
            validation={validations.condicion_imp_iva_ii}
            options={$dictionaries.condicion_iva}
            placeholder="Seleccione una opción."
            bind:value={data.condicion_imp_iva_ii}
        />
    </Row>
{/if}
{#if allowInputs('condicion_imp_ganancias_ii') && !providerSiniestros}
    <Row>
        <SelectX
            required
            name="condicion_imp_ganancias_ii"
            label="Condición Frente al Impuesto de Ganancias"
            options={$dictionaries.condicion_ganancias}
            placeholder="Seleccione una opción."
            disabled={!editable}
            validation={validations.condicion_imp_ganancias_ii}
            bind:value={data.condicion_imp_ganancias_ii}
        />
    </Row>
{/if}
{#if allowInputs('condicion_imp_ingresos_ii')}
    <Row>
        <SelectX
            required
            disabled={!editable}
            name="condicion_imp_ingresos_ii"
            label="Condición Frente al Impuesto a los Ingresos Brutos"
            options={$dictionaries.posicion_ingresos}
            validation={validations.condicion_imp_ingresos_ii}
            placeholder="Seleccione una opción."
            bind:value={data.condicion_imp_ingresos_ii}
        />
    </Row>
{/if}
{#if allowInputs('no_ingresos_brutos_ii')}
    <Row>
        <InputText
            required
            disabled={!editable}
            errorMsg="Ingrese un N° Inscripción Ingresos Brutos válido."
            info="El Nro. Inscripción Ingresos Brutos debe contener solo números."
            maxLength={14}
            validation={validations.no_ingresos_brutos_ii}
            bind:value={data.no_ingresos_brutos_ii}
            name="no_ingresos_brutos_ii"
            label="N° Inscripción Ingresos Brutos"
        />
    </Row>
{/if}
{#if allowInputs('empleador_ii')}
    <Row>
        <Select
            bind:value={data.empleador_ii}
            name="empleador_ii"
            label="SUSS – Empleador"
            options={$dictionaries.empleador}
            required={data.condicion_imp_iva_ii === '1'}
            disabled={!(editable && data.condicion_imp_iva_ii === '1')}
            placeholder="Seleccione una opción."
        />
    </Row>
{/if}
<TextArea
    bind:value={data.observaciones_ii}
    name="observaciones_ii"
    disabled={!editable}
    label="Observaciones"
/>
